import React from 'react';

import LaunchIcon from '@mui/icons-material/LaunchOutlined';

import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';

function PackageChip({ id }) {
  const url =
    (id.includes('1Z')
      ? `https://www.ups.com/track?track=yes&trackNums=${id}`
      : `https://www.fedex.com/fedextrack/?trknbr=${id}`) || '';

  return (
    <Chip
      label={
        <Link
          data-cy={`url-${id}`}
          href={url}
          label="test"
          underline="hover"
          target="_blank"
          rel="noreferrer"
          alignItems="center"
        >
          {id}
          <LaunchIcon fontSize="small" />
        </Link>
      }
    />
  );
}

export default React.memo(PackageChip);
